import ConferenceOutstandingPaymentPage from "../components/conferences/outstandingPayment";

const ConferenceOutstandingPayment = () => {
  return <ConferenceOutstandingPaymentPage />;
};

export default ConferenceOutstandingPayment;
